import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/pages/home/home')
    },
    {
      path: '/status',
      name: 'status',
      component: () => import('@/pages/status/status')
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/pages/upload/upload')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js